import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

import { WEB_TYPES } from './NavigationRedux'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  domexCalculateRequest: null,
  domexCalculateRequestSuccess: ['calculateResult'],
  domexCalculateRequestFailure: ['calculateErrors'],
  domexGetParamsRequest: null,
  domexSaveParamsRequestSuccess: ['response'],
  domexSetOccupancy: ['groundingOccupancyIndex'],
  domexSetPropertyType: ['groundingPropertyTypeIndex'],
  domexSetHouseHold: ['householdActive'],
  domexSetLiability: ['liabilityActive'],
  domexSetMaxLiability: ['maximumLiabilityIndex'],
  domexSetProperty: ['propertyActive'],
  domexValidationErrorCustomerFormChange: ['name', 'error', 'screen'],
  domexValidationErrorsHouseholdDetailChange: ['name', 'error', 'screen'],
  domexValidationErrorPropertyTypeChange: ['name', 'error', 'screen'],
  domexSetDefaultForWebType: ['webType'],
  onLoadWebsite: ['website'],
  onChangeGaId: ["gaId"],
  // inputs
  domexSetHiSum: ['hiSumInsured'],
  domexSetHiArea: ['hiHouseholdArea'],
  domexSetGiSum: ['giSumInsured'],
  domexSetGiArea: ['giBuiltUpArea'],
  domexChangeStreet: ['street'],
  domexChangeHouseNo: ['houseNo'],
  domexChangeZipCode: ['zipCode'],
  domexChangeCity: ['city'],
  domexChangePhone: ['phone'],
  domexChangeSurname: ['surname'],
})

export const DomexTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  calculateResult: 0,
  calculateErrors: [],
  groundingInsurance: {
    occupancy: [],
    propertyType: []
  },
  groundingOccupancyIndex: 0,
  groundingPropertyTypeIndex: 1,
  householdInsurance: [],
  householdActive: false,
  maximumLiability: [],
  liabilityActive: false,
  propertyActive: true,
  maximumLiabilityIndex: -1,
  gaId: '',
  // inputs
  giBuiltUpArea: '',
  giSumInsured: '',
  hiHouseholdArea: '',
  hiSumInsured: '',
  street: '',
  houseNo: '',
  zipCode: '',
  city: '',
  phone: '',
  surname: '',
  validationErrorsCustomerForm: {},
  validationErrorsHouseholdDetail: {},
  validationErrorsPropertyType: {},
  website: '',
})

/* ------------- Reducers ------------- */

export const params = state => state

export const setParams = (state, { response }) =>
  state.merge({
    groundingInsurance: {
      occupancy: response.groundingInsurance.occupancy,
      propertyType: response.groundingInsurance.propertyType
    },
    householdInsurance: response.houseHoldInsurance.occupancy,
    maximumLiability: response.liabilityInsurance.maximumLiabiity
  })

export const calculate = state => state

export const getCalculateResult = (state, { calculateResult }) =>
  state.merge({
    calculateResult
  })

export const setOccupancy = (state, { groundingOccupancyIndex }) =>
  state.merge({
    groundingOccupancyIndex
  })

export const setPropertyType = (state, { groundingPropertyTypeIndex }) =>
  state.merge({
    groundingPropertyTypeIndex
  })

export const changeGaId = (state, { gaId }) =>
  state.merge({ gaId })

export const loadWebsite = (state, { website }) =>
  state.merge({ website })

export const setHouseHold = (state, { householdActive }) =>
  state.merge({
    householdActive
  })

export const setLiability = (state, { liabilityActive }) =>
  state.merge({
    liabilityActive
  })

export const setProperty = (state, { propertyActive }) =>
  state.merge({ propertyActive })

export const setMaxLiability = (state, { maximumLiabilityIndex }) =>
  state.merge({
    maximumLiabilityIndex
  })

// inputs
export const setGiBuiltUpArea = (state, { giBuiltUpArea }) =>
  state.merge({
    giBuiltUpArea
  })

export const setGiSumInsured = (state, { giSumInsured }) =>
  state.merge({
    giSumInsured
  })

export const setHiHouseholdArea = (state, { hiHouseholdArea }) =>
  state.merge({
    hiHouseholdArea
  })

export const setHiSumInsured = (state, { hiSumInsured }) =>
  state.merge({
    hiSumInsured
  })

export const changeStreet = (state, { street }) =>
  state.merge({ street })

export const changeHouseNo = (state, { houseNo }) =>
  state.merge({ houseNo })

export const changeZipCode = (state, { zipCode }) =>
  state.merge({ zipCode })

export const changeCity = (state, { city }) =>
  state.merge({ city })

export const changePhone = (state, { phone }) =>
  state.merge({ phone })

export const changeSurname = (state, { surname }) =>
  state.merge({ surname })

export const validationErrorCustomerFormChange = (state, { name, error }) => {
  const validationErrorsCustomerForm = { ...state.validationErrorsCustomerForm }
  validationErrorsCustomerForm[name] = error
  return state.merge({ validationErrorsCustomerForm })
}

export const validationErrorsHouseholdDetailChange = (state, { name, error }) => {
  const validationErrorsHouseholdDetail = { ...state.validationErrorsHouseholdDetail }
  validationErrorsHouseholdDetail[name] = error
  return state.merge({ validationErrorsHouseholdDetail })
}

export const validationErrorPropertyTypeChange = (state, { name, error }) => {
  const validationErrorsPropertyType = { ...state.validationErrorsPropertyType }
  validationErrorsPropertyType[name] = error
  return state.merge({ validationErrorsPropertyType })
}

export const getCalculateErrors = (state, { calculateErrors }) => {

  const validationErrorsCustomerForm = { ...state.validationErrorsCustomerForm }
  const validationErrorsHouseholdDetail = { ...state.validationErrorsHouseholdDetail }
  const validationErrorsPropertyType = { ...state.validationErrorsPropertyType }

  calculateErrors.map(error => {
    switch (error.field) {
      case 'giBuiltUpArea':
      case 'giSumInsured':
        return validationErrorsPropertyType[error.field] = error.message
      case 'hiHouseholdArea':
      case 'hiSumInsured':
        return validationErrorsHouseholdDetail[error.field] = error.message
      default:
        return validationErrorsCustomerForm[error.field] = error.message
    }
  })

  return state.merge({
    validationErrorsCustomerForm,
    validationErrorsHouseholdDetail,
    validationErrorsPropertyType
  })
}

export const setDefaultForWebType = (state, { webType }) => {
  const householdActive = webType === WEB_TYPES.HOUSEHOLD
  const liabilityActive = webType === WEB_TYPES.LIABILITY
  const propertyActive = webType === WEB_TYPES.DEFAULT
  return state.merge({ householdActive, liabilityActive, propertyActive })
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.DOMEX_GET_PARAMS_REQUEST]: params,
  [Types.DOMEX_SAVE_PARAMS_REQUEST_SUCCESS]: setParams,
  [Types.DOMEX_CALCULATE_REQUEST]: calculate,
  [Types.DOMEX_CALCULATE_REQUEST_SUCCESS]: getCalculateResult,
  [Types.DOMEX_CALCULATE_REQUEST_FAILURE]: getCalculateErrors,
  [Types.DOMEX_SET_OCCUPANCY]: setOccupancy,
  [Types.DOMEX_SET_PROPERTY_TYPE]: setPropertyType,
  [Types.DOMEX_SET_HOUSE_HOLD]: setHouseHold,
  [Types.DOMEX_SET_LIABILITY]: setLiability,
  [Types.DOMEX_SET_MAX_LIABILITY]: setMaxLiability,
  [Types.DOMEX_SET_PROPERTY]: setProperty,
  [Types.ON_LOAD_WEBSITE]: loadWebsite,
  [Types.ON_CHANGE_GA_ID]: changeGaId,
  // inputs
  [Types.DOMEX_SET_HI_SUM]: setHiSumInsured,
  [Types.DOMEX_SET_HI_AREA]: setHiHouseholdArea,
  [Types.DOMEX_SET_GI_SUM]: setGiSumInsured,
  [Types.DOMEX_SET_GI_AREA]: setGiBuiltUpArea,
  [Types.DOMEX_CHANGE_STREET]: changeStreet,
  [Types.DOMEX_CHANGE_HOUSE_NO]: changeHouseNo,
  [Types.DOMEX_CHANGE_ZIP_CODE]: changeZipCode,
  [Types.DOMEX_CHANGE_CITY]: changeCity,
  [Types.DOMEX_CHANGE_PHONE]: changePhone,
  [Types.DOMEX_CHANGE_SURNAME]: changeSurname,
  [Types.DOMEX_VALIDATION_ERROR_CUSTOMER_FORM_CHANGE]: validationErrorCustomerFormChange,
  [Types.DOMEX_VALIDATION_ERRORS_HOUSEHOLD_DETAIL_CHANGE]: validationErrorsHouseholdDetailChange,
  [Types.DOMEX_VALIDATION_ERROR_PROPERTY_TYPE_CHANGE]: validationErrorPropertyTypeChange,
  [Types.DOMEX_SET_DEFAULT_FOR_WEB_TYPE]: setDefaultForWebType,
})
